<div class="print-container">
    <h1 class="page-label">Outbound Validation - Enter Info</h1>
    <h4 class="page-label">Selected Portal: {{ portal?.name }}</h4>
</div>

<div class="print-container">
    <div>
        <div class="row">
            <label class="col-sm-5 input-label" for="po-number-input">Container ID:</label>
            <input [(ngModel)]="containerId" class="col-sm-7 form-control" id="container-id-input" type="text" [readonly]="isUiDisabled" [disabled]="isUiDisabled">
        </div>
    </div>
</div>

<div class="print-container">
    <div class="row">
        <button (click)="onGetInfoClicked()" class="submit btn btn-primary col-sm-8" [disabled]="isUiDisabled">Get Info</button>
    </div>
</div>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog
    >
</ef-simple-indefinite-progress-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>